import React, { useState, useEffect } from 'react';
import {
    Button,
    Table,
    TableBody,
    TableCell,
    DialogActions,
    DialogTitle,
    DialogContent,
    TableContainer,
    Dialog,
    TableHead,
    TableRow,
    Paper,
    TextField,
    Grid,
    Switch,
    FormControlLabel,
    Tooltip,
    Typography,
    Box,
    Stack,
    Container,
    Divider,
    Chip,
    useMediaQuery
} from '@mui/material';
import axios from 'axios';
import moment from 'moment';
import AddIcon from '@mui/icons-material/Add';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { useNotification } from './context/NotificationContext';

const SERVER_IP = 'https://frek.cc/proxy/38.54.86.24:49152'; // Server IP address
const OTP_FETCH_URL = 'https://frek.cc/proxy/38.54.86.24:5005/simreg'; // OTP fetching URL
const GOIP_PORT_FETCH_URL = 'https://frek.cc/proxy/38.54.86.24:5000/expiry/49151'; // GoIP and Port fetching URL

function Simregbot() {
    const { showNotification } = useNotification();
    const [applicants, setApplicants] = useState([]);
    const [users, setUsers] = useState([]);
    const [fetchedNumbers, setFetchedNumbers] = useState([]);
    const [numberStatus, setNumberStatus] = useState({});
    const [goipPorts, setGoipPorts] = useState([]);
    const [userAmounts, setUserAmounts] = useState({});
    const [amount, setAmount] = useState('');
    const [openEditBatchesDialog, setOpenEditBatchesDialog] = useState(false);
    const [currentTime, setCurrentTime] = useState(moment.utc());
    const [otpData, setOtpData] = useState({});
    const [switchStates, setSwitchStates] = useState([false, false, false, false, false, false, false, false, false, false]);
    const [broadcastMessage, setBroadcastMessage] = useState('');
    const [showApplicants, setShowApplicants] = useState(() => JSON.parse(localStorage.getItem('showApplicants')) ?? true);
    const [showUsers, setShowUsers] = useState(() => JSON.parse(localStorage.getItem('showUsers')) ?? true);
    const [showFetchedNumbers, setShowFetchedNumbers] = useState(() => JSON.parse(localStorage.getItem('showFetchedNumbers')) ?? true);
    const [paymentMethod, setPaymentMethod] = useState('');
    const [showPaymentMethodDialog, setShowPaymentMethodDialog] = useState(false);
    const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
    const [messageToSend, setMessageToSend] = useState('');
    const [userToRemove, setUserToRemove] = useState(null);
    const [userRemoveDialogOpen, setUserRemoveDialogOpen] = useState(false);
    const [actionType, setActionType] = useState('');
    const [openPredefinedDialog, setOpenPredefinedDialog] = useState(false);
    const [selectedUsername, setSelectedUsername] = useState('');
    const [usernameToRemove, setUsernameToRemove] = useState('');
    const [restrictDialogOpen, setRestrictDialogOpen] = useState(false);
    const [restrictReason, setRestrictReason] = useState('');
    const [chatIdToRestrict, setChatIdToRestrict] = useState('');
    const [usernameToRestrict, setUsernameToRestrict] = useState('');
    const [resetAllDialogOpen, setResetAllDialogOpen] = useState(false);
    const isDesktop = useMediaQuery('(min-width:600px)');



    const darkTheme = createTheme({
        palette: {
            mode: 'dark',
            background: {
                default: '#121212',
                paper: '#1e1e1e',
            },
            text: {
                primary: '#c9cdd3',
                secondary: '#9aa3ad',
            },
            success: {
                main: '#4caf50',
            },
            primary: {
                main: '#90caf9',
            },
            secondary: {
                main: '#7bdff2',
            },
        },
        shape: {
            borderRadius: 12,
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        textTransform: 'none',
                        borderRadius: 10,
                        fontWeight: 600,
                    },
                },
            },
        },
    });

    // Save switch states to localStorage
    useEffect(() => {
        localStorage.setItem('showApplicants', JSON.stringify(showApplicants));
        localStorage.setItem('showUsers', JSON.stringify(showUsers));
        localStorage.setItem('showFetchedNumbers', JSON.stringify(showFetchedNumbers));
    }, [showApplicants, showUsers, showFetchedNumbers]);


    // Keep the timer ticking
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTime(moment.utc());
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const predefinedMessages = [
        'New Numbers up ! Lets fucking go !',
        'Sending Payment Now! Yeeeyyyy !',
        'Will Send Payment Tomorrow! Rest Assured that payment will be made :)',
        'Get Ready Preparing Numbers !',
        'Will Resume Work Later , Get some rest for now !',
        'Done for today , We will resume tomorrow . Goodnight guys !',
        'All payment Sent ..'
    ];

    const handleOpenPredefinedDialog = () => {
        setOpenPredefinedDialog(true);
    };

    const handleSelectPredefinedMessage = (message) => {
        setBroadcastMessage(message);
        // Send after state update
        setTimeout(() => {
            sendMessageToUsers();
        }, 0);
    };




    const totalBalance = Object.keys(users).reduce((total, chat_id) => {
        return total + parseFloat(users[chat_id].balance || 0);
    }, 0);

    const handleSendUsernamesAndBalances = () => {
        axios.get(`${SERVER_IP}/users`)
            .then(response => {
                const updatedUsers = response.data;
                const message = Object.keys(updatedUsers)
                    .map(chat_id => {
                        const user = updatedUsers[chat_id];
                        return `@${user.username} = ₱ ${user.balance}`;
                    })
                    .join('\n\n');
                setMessageToSend(message);
                setActionType('balance');
                setConfirmationDialogOpen(true);
            })
            .catch(error => {
                console.error('Error fetching users:', error);
                handleNotification('Failed to fetch the latest user data.');
            });
    };

    const handleSendPaymentMethods = () => {
        axios.get(`${SERVER_IP}/users`)
            .then(response => {
                const updatedUsers = response.data;
                const message = Object.keys(updatedUsers)
                    .map(chat_id => {
                        const user = updatedUsers[chat_id];
                        return `@${user.username} - ${user.payment_method
                            ? user.payment_method
                                .replace('Method: ', '')
                                .replace(', Account Number: ', ', ')
                                .replace(', Name: ', ', ')
                            : 'Not Set'
                            }`;
                    })
                    .join('\n\n');
                setMessageToSend(message);
                setActionType('payment');
                setConfirmationDialogOpen(true);
            })
            .catch(error => {
                console.error('Error fetching users:', error);
                handleNotification('Failed to fetch the latest user data.');
            });
    };


    // 1) Add these functions near your other event handlers:
    const handleRestrictUser = (chat_id) => {
        setChatIdToRestrict(chat_id);
        setUsernameToRestrict(users[chat_id]?.username || 'Unknown');
        setRestrictDialogOpen(true);
    };

    const confirmRestrictUser = () => {
        axios
            .post(`${SERVER_IP}/manual_restrict_user`, {
                chat_id: chatIdToRestrict,
                reason: restrictReason || 'No reason provided',
            })
            .then(() => {
                handleNotification(`User @${usernameToRestrict} restricted successfully!`);
                fetchUsers();
            })
            .catch(error => {
                console.error('Error restricting user:', error);
                handleNotification('Failed to restrict user.', 'error');
            });

        // Reset everything
        setRestrictDialogOpen(false);
        setRestrictReason('');
        setChatIdToRestrict('');
        setUsernameToRestrict('');
    };


    const handleUnrestrictUser = (chat_id) => {
        axios
            .post(`${SERVER_IP}/manual_unrestrict_user`, { chat_id })
            .then(() => {
                handleNotification(`User ${chat_id} unrestricted successfully!`);
                fetchUsers();
            })
            .catch(error => {
                console.error('Error unrestricting user:', error);
                handleNotification('Failed to unrestrict user.', 'error');
            });
    };

    const handleToggleGroupNotification = (chat_id, enabled) => {
        axios
            .post(`${SERVER_IP}/toggle_group_notification`, { chat_id, enabled })
            .then(response => {
                const isEnabled = response.data.group_notifications_enabled;
                handleNotification(`Group notification ${isEnabled ? 'enabled' : 'disabled'} for ${users[chat_id]?.username || chat_id}.`);
                fetchUsers();
            })
            .catch(error => {
                console.error('Error toggling group notification:', error);
                handleNotification('Failed to update group notification setting.', 'error');
            });
    };

    const handleViewPaymentMethod = (chat_id) => {
        const user = users[chat_id];

        if (user) {
            setSelectedUsername(user.username || 'Unknown');
            setPaymentMethod(user.payment_method || 'No payment method set');
        } else {
            setSelectedUsername('Unknown');
            setPaymentMethod('No payment method set');
        }

        setShowPaymentMethodDialog(true);
    };



    const handleConfirmAction = () => {
        fetch('https://frek.cc/proxy/38.54.86.24:49152/post', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ message: messageToSend }),
        })
            .then(response => {
                if (response.ok) {
                    handleNotification('Message sent successfully!');
                } else {
                    handleNotification('Failed to send the message.');
                }
            })
            .catch(error => {
                console.error('Error sending message:', error);
                handleNotification('Failed to send the message.');
            });
        setConfirmationDialogOpen(false);
    };

    const handleSwitchChange = (index) => {
        const updatedSwitches = switchStates.map((state, i) => (i === index ? !state : state));
        setSwitchStates(updatedSwitches);
    };

    // Fetch GoIP ports
    const fetchGoipPorts = () => {
        axios
            .get(GOIP_PORT_FETCH_URL)
            .then(response => {
                setGoipPorts(response.data[0].value.split(',').map(Number).sort((a, b) => a - b));
            })
            .catch(error => console.error('Error fetching GoIP ports:', error));
    };

    // Applicants
    const fetchApplicants = () => {
        if (showApplicants) {
            axios
                .get(`${SERVER_IP}/applicants`)
                .then(response => setApplicants(response.data))
                .catch(error => console.error('Error fetching applicants:', error));
        }
    };

    // Users
    const fetchUsers = () => {
        if (showUsers) {
            axios
                .get(`${SERVER_IP}/users`)
                .then(response => setUsers(response.data))
                .catch(error => console.error('Error fetching users:', error));
        }
    };

    const handleEditBatchesClick = () => {
        axios
            .get(GOIP_PORT_FETCH_URL)
            .then(response => {
                const activeBatches = response.data[0].value.split(',').map(Number);
                const newSwitchStates = switchStates.map((_, index) => activeBatches.includes(index));
                setSwitchStates(newSwitchStates);
                setOpenEditBatchesDialog(true);
            })
            .catch(error => {
                console.error('Error fetching switch state:', error);
                handleNotification('Failed to fetch current switch state.');
            });
    };

    useEffect(() => {
        document.title = 'Simreg Bot Manager';
    }, []);

    const handleEditBatches = () => {
        const activeBatches = [];
        switchStates.forEach((state, index) => {
            if (index > 0 && state) {
                activeBatches.push(index);
            }
        });

        fetch('https://frek.cc/proxy/38.54.86.24:5000/expiry/49151', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ value: activeBatches.join(',') }),
        })
            .then(response => response.json())
            .then(data => {
                handleNotification('Batches Edited Success!');
            })
            .catch(error => {
                console.error('Error submitting batch indexes:', error);
            });

        setOpenEditBatchesDialog(false);
    };

    // Fetched numbers
    const fetchFetchedNumbers = () => {
        if (showFetchedNumbers) {
            axios
                .get(`${SERVER_IP}/fetched_numbers`)
                .then(response => setFetchedNumbers(response.data))
                .catch(error => console.error('Error fetching fetched numbers:', error));
        }
    };

    // Number status
    const fetchNumberStatus = () => {
        axios
            .get(`${SERVER_IP}/number_status`)
            .then(response => setNumberStatus(response.data))
            .catch(error => console.error('Error fetching number status:', error));
    };

    // Send message to all users + group
    const sendMessageToUsers = () => {
        axios
            .post(`${SERVER_IP}/send_message_to_users`, { message: broadcastMessage })
            .then(() => {
                handleNotification('Message sent successfully to all approved users!');
                // Also post to group
                axios
                    .post(
                        'https://frek.cc/proxy/38.54.86.24:49152/post',
                        { message: broadcastMessage },
                        { headers: { 'Content-Type': 'application/json' } }
                    )
                    .then(() => {
                        handleNotification('Message sent successfully to the group!');
                    })
                    .catch(error => {
                        console.error('Error sending message to the group:', error);
                        handleNotification('Failed to send the message to the group.', 'error');
                    });
            })
            .catch(error => {
                console.error('Error sending message to users:', error);
                handleNotification('Failed to send the message to users.', 'error');
            });
    };

    const handleNotification = (message, severity = 'success') => {
        showNotification(message, severity);
    };

    // Fetch OTPs
    const fetchOtps = () => {
        axios
            .get(OTP_FETCH_URL)
            .then(response => {
                const otps = {};
                response.data.forEach(message => {
                    const { content, receiver } = message;
                    const otpMatch = content.match(/Your One-Time-Password \(OTP\) for SIM Registration is (\d{6})/);
                    if (otpMatch) {
                        if (!otps[receiver]) {
                            otps[receiver] = [];
                        }
                        otps[receiver].push(otpMatch[1]);
                    }
                });
                setOtpData(otps);
            })
            .catch(error => console.error('Error fetching OTPs:', error));
    };

    // Fetch applicants every 15s if showApplicants true
    useEffect(() => {
        if (showApplicants) {
            fetchApplicants();
            const interval = setInterval(() => {
                fetchApplicants();
            }, 15000);
            return () => clearInterval(interval);
        }
    }, [showApplicants]);

    // Fetch users every 10s if showUsers true
    useEffect(() => {
        if (showUsers) {
            fetchUsers();
            const interval = setInterval(() => {
                fetchUsers();
            }, 10000);
            return () => clearInterval(interval);
        }
    }, [showUsers]);

    // Fetched numbers, status, OTPs, goip ports every 7s if showFetchedNumbers true
    useEffect(() => {
        if (showFetchedNumbers) {
            fetchFetchedNumbers();
            fetchNumberStatus();
            fetchOtps();
            fetchGoipPorts();

            const interval = setInterval(() => {
                fetchFetchedNumbers();
                fetchNumberStatus();
                fetchOtps();
                fetchGoipPorts();
            }, 7000);
            return () => clearInterval(interval);
        }
    }, [showFetchedNumbers]);

    // Approve applicant
    const handleApprove = (chat_id) => {
        axios
            .post(`${SERVER_IP}/applicants`, { chat_id, action: 'approve' })
            .then(() => {
                fetchApplicants();
                handleNotification('Applicant approved successfully!');
            })
            .catch(error => {
                console.error('Error approving applicant:', error);
                handleNotification('Failed to approve applicant.');
            });
    };

    // Deny applicant
    const handleDeny = (chat_id) => {
        axios
            .post(`${SERVER_IP}/applicants`, { chat_id, action: 'deny' })
            .then(() => {
                fetchApplicants();
                handleNotification('Applicant denied successfully!');
            })
            .catch(error => {
                console.error('Error denying applicant:', error);
                handleNotification('Failed to deny applicant.');
            });
    };

    // Update balance
    const handleUpdateBalance = (chat_id, change) => {
        const amount = parseFloat(userAmounts[chat_id]);
        if (isNaN(amount)) {
            handleNotification('Please enter a valid amount.');
            return;
        }
        axios
            .post(`${SERVER_IP}/add_balance`, { chat_id, amount: change })
            .then(() => {
                fetchUsers();
                handleNotification(`Balance ${change > 0 ? 'added' : 'deducted'} successfully!`);
                setUserAmounts({ ...userAmounts, [chat_id]: '' });
            })
            .catch(error => {
                console.error('Error updating balance:', error);
                handleNotification('Failed to update balance.');
            });
    };

    // Reset all balances
    const handleResetBalances = async () => {
        const chatIds = Object.keys(users);
        if (!chatIds.length) {
            handleNotification('No users found.', 'error');
            return;
        }

        let successCount = 0;
        let failedCount = 0;

        for (const chat_id of chatIds) {
            const currentBalance = parseFloat(users[chat_id]?.balance || 0);
            if (isNaN(currentBalance) || currentBalance === 0) {
                continue;
            }

            try {
                await axios.post(`${SERVER_IP}/add_balance`, { chat_id, amount: -currentBalance });
                successCount += 1;
            } catch (error) {
                console.error(`Error resetting balance for user ${users[chat_id].username}:`, error);
                failedCount += 1;
            }
        }

        fetchUsers();
        if (failedCount > 0) {
            handleNotification(`Reset completed: ${successCount} success, ${failedCount} failed.`, 'error');
            return;
        }

        handleNotification(`All balances reset to zero (${successCount} updated).`);
    };

    // Confirm removal
    const confirmRemoveUser = () => {
        if (userToRemove) {
            axios
                .post(`${SERVER_IP}/users`, { chat_id: userToRemove })
                .then(() => {
                    fetchUsers();
                    handleNotification('User removed successfully!');
                })
                .catch(error => {
                    console.error('Error removing user:', error);
                    handleNotification('Failed to remove user.');
                });
            setUserToRemove(null);
        }
        setUserRemoveDialogOpen(false);
    };

    // Remove user
    const handleRemoveUser = (chat_id) => {
        setUserToRemove(chat_id);
        setUsernameToRemove(users[chat_id]?.username || 'Unknown');
        setUserRemoveDialogOpen(true);
    };


    // Calculate goip/port
    const getGoipAndPort = (index) => {
        let cumulativePorts = 0;
        const hasG1 = goipPorts.includes(1);
        for (let i = 0; i < goipPorts.length; i++) {
            const goip = goipPorts[i];
            const goipPortCount = hasG1 && goip === 1 ? 30 : 32;
            if (index < cumulativePorts + goipPortCount) {
                const port = index - cumulativePorts + 1;
                return { goip: `g${goip}`, port };
            }
            cumulativePorts += goipPortCount;
        }
        return { goip: 'N/A', port: 'N/A' };
    };

    const getNumberInfo = (number, index) => {
        let status = 'Empty';
        let notes = '';
        let mostRecentNote = '';
        let takenBy = '';
        let timer = '';
        let additionalStatus = '';
        let takenCount = 0;
        let otpCount = 0;
        let otps = [];
        let mostRecentOtp = '';
        const { goip, port } = getGoipAndPort(index);

        if (number) {
            if (
                numberStatus.completed_numbers &&
                numberStatus.completed_numbers.some(item => item.number === number)
            ) {
                const completedInfo = numberStatus.completed_numbers.find(item => item.number === number);
                status = '';
                additionalStatus = completedInfo.status;
                notes = completedInfo.notes.join(', ');
                otpCount = completedInfo.otp_count || 0;
                mostRecentNote = completedInfo.notes[completedInfo.notes.length - 1] || '';
            } else if (numberStatus.available_numbers && numberStatus.available_numbers.includes(number)) {
                status = 'Unregistered';
            } else if (numberStatus.processing_numbers) {
                const processInfo = Object.values(numberStatus.processing_numbers).find(
                    item => item.number === number
                );
                if (processInfo) {
                    status = 'Registering';
                    notes = processInfo.notes.join(', ');
                    takenBy = processInfo.taken_by;
                    otpCount = processInfo.otp_count || 0;
                    mostRecentNote = processInfo.notes[processInfo.notes.length - 1] || '';

                    const timeTaken = moment.utc(processInfo.taken_at);
                    const now = currentTime;
                    const diff = 600 - now.diff(timeTaken, 'seconds');
                    const minutes = Math.floor(diff / 60);
                    const seconds = diff % 60;

                    timer = diff > 0 ? `${minutes}:${seconds}` : 'Exp';
                }
            }

            if (numberStatus.no_otp_numbers) {
                const noOtpInfo = numberStatus.no_otp_numbers.find(item => item.number === number);
                if (noOtpInfo) {
                    status = 'No OTP';
                    takenCount = noOtpInfo.taken_count;
                    otpCount = noOtpInfo.otp_count || 0;
                }
            }

            otps = otpData[number] || [];
            mostRecentOtp = otps[otps.length - 1] || '';
        }

        return {
            goip,
            port,
            status,
            notes,
            mostRecentNote,
            takenBy,
            timer,
            additionalStatus,
            takenCount,
            otpCount,
            otps,
            mostRecentOtp,
        };
    };

    const getStatusDisplay = (status, mostRecentNote) => {
        if (status === 'Registered' || mostRecentNote === 'Registration successful') {
            return {
                label: 'Registered',
                color: '#37d67a',
                icon: <CheckCircleIcon sx={{ fontSize: 16, color: '#37d67a' }} />,
            };
        }
        if (status === 'Registering') {
            return {
                label: 'Registering',
                color: '#ffb74d',
                icon: <AutorenewIcon sx={{ fontSize: 16, color: '#ffb74d' }} />,
            };
        }
        if (status === 'No OTP') {
            return {
                label: 'No OTP',
                color: '#ffb74d',
                icon: <ErrorOutlineIcon sx={{ fontSize: 16, color: '#ffb74d' }} />,
            };
        }
        if (mostRecentNote === 'Registration under review') {
            return {
                label: 'Review',
                color: '#ff6b6b',
                icon: <ErrorOutlineIcon sx={{ fontSize: 16, color: '#ff6b6b' }} />,
            };
        }
        return {
            label: status || 'Unknown',
            color: 'rgba(255,255,255,0.75)',
            icon: <HelpOutlineIcon sx={{ fontSize: 16, color: 'rgba(255,255,255,0.55)' }} />,
        };
    };

    return (
        <ThemeProvider theme={darkTheme}>
            <CssBaseline />
            <Box
                sx={{
                    minHeight: '100vh',
                    background:
                        'radial-gradient(1200px 600px at 15% -10%, rgba(78, 118, 255, 0.28), transparent 60%),' +
                        'radial-gradient(900px 600px at 110% 10%, rgba(0, 200, 170, 0.22), transparent 55%),' +
                        'linear-gradient(180deg, #0b0b10 0%, #101018 45%, #0d0f12 100%)',
                    color: '#e8e9ee',
                    py: 3,
                }}
            >
                <Container maxWidth="xl" sx={{ px: { xs: 1.5, sm: 2.5 } }}>
                    <Stack spacing={2.5}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'column', md: 'row' },
                                alignItems: { xs: 'flex-start', md: 'center' },
                                justifyContent: 'space-between',
                                gap: 1,
                                flexWrap: 'wrap',
                            }}
                        >

                            <Stack
                                direction="row"
                                spacing={1}
                                alignItems="center"
                                sx={{
                                    flexWrap: 'wrap',
                                    rowGap: 1,
                                    justifyContent: { xs: 'flex-start', md: 'flex-end' },
                                    width: { xs: '100%', md: 'auto' },
                                }}
                            >
                                <Chip
                                    label={`Applicants: ${Object.keys(applicants).length}`}
                                    size="small"
                                    sx={{
                                        color: '#d9ecff',
                                        bgcolor: 'rgba(86, 156, 255, 0.18)',
                                        border: '1px solid rgba(255,255,255,0.08)',
                                    }}
                                />
                                <Chip
                                    label={`Users: ${Object.keys(users).length}`}
                                    size="small"
                                    sx={{
                                        color: '#d9ecff',
                                        bgcolor: 'rgba(86, 156, 255, 0.12)',
                                        border: '1px solid rgba(255,255,255,0.08)',
                                    }}
                                />
                                <Chip
                                    label={`Fetched: ${fetchedNumbers.length}`}
                                    size="small"
                                    sx={{
                                        color: '#e8ffe9',
                                        bgcolor: 'rgba(32, 201, 151, 0.18)',
                                        border: '1px solid rgba(255,255,255,0.08)',
                                    }}
                                />
                                <Chip
                                    label={`GoIP Ports: ${goipPorts.length}`}
                                    size="small"
                                    sx={{
                                        color: '#e8ffe9',
                                        bgcolor: 'rgba(32, 201, 151, 0.12)',
                                        border: '1px solid rgba(255,255,255,0.08)',
                                    }}
                                />
                                <Chip
                                    label={`Total Balance: PHP ${totalBalance}`}
                                    size="small"
                                    sx={{
                                        color: '#f7f0ff',
                                        bgcolor: 'rgba(147, 112, 219, 0.18)',
                                        border: '1px solid rgba(255,255,255,0.08)',
                                    }}
                                />
                            </Stack>
                        </Box>

                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                borderRadius: 3,
                                background: 'rgba(18, 18, 22, 0.75)',
                                border: '1px solid rgba(255,255,255,0.06)',
                                backdropFilter: 'blur(6px)',
                            }}
                        >
                            <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'rgba(255,255,255,0.8)', mb: 1 }}>
                                Controls
                            </Typography>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} md={6}>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} flexWrap="wrap">
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={showApplicants}
                                                    onChange={e => setShowApplicants(e.target.checked)}
                                                    sx={{ transform: 'scale(0.85)' }}
                                                    />
                                                }
                                                label="Applicants"
                                                sx={{ '& .MuiFormControlLabel-label': { fontSize: 12, color: 'rgba(255,255,255,0.65)' } }}
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Switch checked={showUsers} onChange={e => setShowUsers(e.target.checked)} sx={{ transform: 'scale(0.85)' }} />
                                                }
                                                label="Users"
                                                sx={{ '& .MuiFormControlLabel-label': { fontSize: 12, color: 'rgba(255,255,255,0.65)' } }}
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={showFetchedNumbers}
                                                        onChange={e => setShowFetchedNumbers(e.target.checked)}
                                                        sx={{ transform: 'scale(0.85)' }}
                                                    />
                                                }
                                                label="Fetched Numbers"
                                                sx={{ '& .MuiFormControlLabel-label': { fontSize: 12, color: 'rgba(255,255,255,0.65)' } }}
                                            />
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Stack spacing={1}>
                                        <TextField
                                            type="text"
                                            label="Broadcast message"
                                            value={broadcastMessage}
                                            onChange={e => setBroadcastMessage(e.target.value)}
                                            fullWidth
                                            size="small"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    backgroundColor: 'rgba(255,255,255,0.04)',
                                                    borderRadius: 2,
                                                },
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'rgba(255,255,255,0.12)',
                                                },
                                            }}
                                        />
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} flexWrap="wrap">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={sendMessageToUsers}
                                                sx={{ width: { xs: '100%', sm: 'auto' } }}
                                            >
                                                Send to All
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                onClick={handleOpenPredefinedDialog}
                                                sx={{ width: { xs: '100%', sm: 'auto' } }}
                                            >
                                                Send Formatted
                                            </Button>
                                        </Stack>
                                    </Stack>
                                </Grid>
                            </Grid>
                            <Divider sx={{ my: 2, borderColor: 'rgba(255,255,255,0.08)' }} />
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} flexWrap="wrap">
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={handleEditBatchesClick}
                                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                                >
                                    Edit GoIP
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={handleSendUsernamesAndBalances}
                                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                                >
                                    Send User Balance
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    onClick={handleSendPaymentMethods}
                                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                                >
                                    Send Users Payment Method
                                </Button>
                                <Button
                                    variant="contained"
                                    color="warning"
                                    onClick={() => setResetAllDialogOpen(true)}
                                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                                >
                                    Reset All Balances
                                </Button>
                            </Stack>
                        </Paper>

                {/* Confirmation Dialog */}
                <Dialog
                    open={confirmationDialogOpen}
                    onClose={() => setConfirmationDialogOpen(false)}
                >
                    <DialogTitle>Confirm Action</DialogTitle>
                    <DialogContent>
                        <p>
                            Are you sure you want to send the{' '}
                            {actionType === 'balance' ? 'usernames and balances' : 'payment methods'}?
                        </p>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setConfirmationDialogOpen(false)}>Cancel</Button>
                        <Button onClick={handleConfirmAction} color="primary">
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Predefined Messages Dialog */}
                <Dialog open={openPredefinedDialog} onClose={() => setOpenPredefinedDialog(false)}>
                    <DialogTitle>Select a Predefined Message</DialogTitle>
                    <DialogContent>
                        {predefinedMessages.map((message, index) => (
                            <Button
                                key={index}
                                onClick={() => handleSelectPredefinedMessage(message)}
                                style={{ marginBottom: '10px', width: '100%' }}
                            >
                                {message}
                            </Button>
                        ))}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenPredefinedDialog(false)}>Cancel</Button>
                    </DialogActions>
                </Dialog>

                <Grid container spacing={1.5}>
                {/* Applicants Section */}
                {showApplicants && (
                    <Grid item xs={12}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                borderRadius: 3,
                                background: 'rgba(18, 18, 22, 0.75)',
                                border: '1px solid rgba(255,255,255,0.06)',
                                backdropFilter: 'blur(6px)',
                            }}
                        >
                            <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                                <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'rgba(255,255,255,0.8)' }}>
                                    Applicants
                                </Typography>
                                <Chip
                                    label={`${Object.keys(applicants).length} pending`}
                                    size="small"
                                    sx={{
                                        color: '#d9ecff',
                                        bgcolor: 'rgba(86, 156, 255, 0.18)',
                                        border: '1px solid rgba(255,255,255,0.08)',
                                    }}
                                />
                            </Stack>
                            <TableContainer
                                component={Paper}
                                sx={{
                                    borderRadius: 2,
                                    overflowX: 'hidden',
                                    background: 'rgba(14, 16, 20, 0.9)',
                                }}
                            >
                                <Table
                                    stickyHeader
                                    size="small"
                                    sx={{
                                        "& td": { color: "rgba(255,255,255,0.82)", borderColor: "rgba(255,255,255,0.06)" },
                                        "& td, & th": { whiteSpace: 'normal', wordBreak: 'break-word', padding: '8px 10px' },
                                        "& th": { fontSize: 12.5 },
                                    }}
                                >
                                <TableHead sx={{ '& th': { backgroundColor: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.7)', fontWeight: 600 } }}>
                                    <TableRow>
                                        <TableCell
                                            sx={{ fontSize: 13, fontWeight: 500, color: 'text.primary' }}
                                            align="center"
                                            style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}
                                        >
                                            User
                                        </TableCell>
                                        
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Object.keys(applicants).map(chat_id => (
                                        <TableRow key={chat_id}>
                                            <TableCell
                                                sx={{ fontSize: 13.1, fontWeight: 200 }}
                                                align="center"
                                                style={{
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 1,
                                                    paddingRight: 1,
                                                }}
                                            >
                                                {applicants[chat_id].username}
                                                <Stack
                                                    direction={{ xs: 'column', sm: 'row' }}
                                                    spacing={1}
                                                    justifyContent="center"
                                                    sx={{ mt: 1 }}
                                                >
                                                    <Button
                                                        size="small"
                                                        variant="contained"
                                                        color="success"
                                                        sx={{ boxShadow: 'none' }}
                                                        onClick={() => handleApprove(chat_id)}
                                                    >
                                                        Approve
                                                    </Button>
                                                    <Button
                                                        size="small"
                                                        variant="outlined"
                                                        color="error"
                                                        onClick={() => handleDeny(chat_id)}
                                                    >
                                                        Deny
                                                    </Button>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                                    </Table>
                                </TableContainer>
                        </Paper>
                    </Grid>
                )}

                {/* Users Section */}
                {showUsers && (
                    <Grid item xs={12}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                borderRadius: 3,
                                background: 'rgba(18, 18, 22, 0.75)',
                                border: '1px solid rgba(255,255,255,0.06)',
                                backdropFilter: 'blur(6px)',
                            }}
                        >
                            <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                                <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'rgba(255,255,255,0.8)' }}>
                                    Users
                                </Typography>
                                <Chip
                                    label={`${Object.keys(users).length} total`}
                                    size="small"
                                    sx={{
                                        color: '#d9ecff',
                                        bgcolor: 'rgba(86, 156, 255, 0.18)',
                                        border: '1px solid rgba(255,255,255,0.08)',
                                    }}
                                />
                            </Stack>
                            <TableContainer
                                component={Paper}
                                sx={{
                                    borderRadius: 2,
                                    overflowX: 'hidden',
                                    background: 'rgba(14, 16, 20, 0.9)',
                                }}
                            >
                                <Table
                                    stickyHeader
                                    size="small"
                                    sx={{
                                        "& td": { color: "rgba(255,255,255,0.82)", borderColor: "rgba(255,255,255,0.06)" },
                                        "& td, & th": { whiteSpace: 'normal', wordBreak: 'break-word', padding: '8px 10px' },
                                        "& th": { fontSize: 12.5 },
                                    }}
                                >
                                <TableHead sx={{ '& th': { backgroundColor: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.7)', fontWeight: 600 } }}>
                                    <TableRow>
                                        <TableCell
                                            sx={{ fontSize: 13, fontWeight: 500, color: 'text.primary' }}
                                            align="center"
                                            style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}
                                        >
                                            User
                                        </TableCell>
                                        <TableCell
                                            sx={{ fontSize: 13, fontWeight: 500, color: 'text.primary' }}
                                            align="center"
                                            style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}
                                        >
                                            Balance
                                        </TableCell>
                                        <TableCell
                                            sx={{ fontSize: 13, fontWeight: 500, color: 'text.primary', display: { xs: 'none', sm: 'table-cell' } }}
                                            align="center"
                                            style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}
                                        >
                                            Group Notice
                                        </TableCell>
                                        <TableCell
                                            sx={{ fontSize: 13, fontWeight: 500, color: 'text.primary', display: { xs: 'none', sm: 'table-cell' } }}
                                            align="center"
                                            style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}
                                        >
                                            Actions
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Object.keys(users).map((chat_id, index) => (
                                        <TableRow
                                            key={chat_id}
                                            sx={{
                                                backgroundColor: index % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'transparent',
                                                '& > td': { borderBottom: '1px solid rgba(255,255,255,0.12)' },
                                            }}
                                        >
                                            <TableCell
                                                sx={{ fontSize: 13.1, fontWeight: 200 }}
                                                align="center"
                                                style={{
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 1,
                                                    paddingRight: 1,
                                                }}
                                            >
                                                {users[chat_id].username}
                                                <Stack
                                                    spacing={1}
                                                    alignItems="center"
                                                    sx={{ mt: 1, display: { xs: 'flex', sm: 'none' } }}
                                                >
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                size="small"
                                                                checked={users[chat_id].group_notifications_enabled ?? true}
                                                                onChange={e => handleToggleGroupNotification(chat_id, e.target.checked)}
                                                            />
                                                        }
                                                        label="Group Notice"
                                                        sx={{
                                                            m: 0,
                                                            '& .MuiFormControlLabel-label': {
                                                                fontSize: '0.75rem',
                                                                color: 'rgba(255,255,255,0.72)',
                                                            },
                                                        }}
                                                    />
                                                    <Stack direction="row" spacing={0.75} alignItems="center" flexWrap="wrap">
                                                        <TextField
                                                            value={userAmounts[chat_id] || ''}
                                                            onChange={e => setUserAmounts({ ...userAmounts, [chat_id]: e.target.value })}
                                                            variant="outlined"
                                                            size="small"
                                                            sx={{
                                                                width: 64,
                                                                '& .MuiOutlinedInput-root': {
                                                                    minHeight: 28,
                                                                    fontSize: '0.8rem',
                                                                    padding: 0,
                                                                    backgroundColor: 'rgba(255,255,255,0.04)',
                                                                },
                                                                '& .MuiOutlinedInput-input': {
                                                                    padding: '4px 8px',
                                                                    textAlign: 'center',
                                                                },
                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                    borderColor: 'rgba(255,255,255,0.12)',
                                                                },
                                                            }}
                                                        />
                                                        <Button
                                                            variant="contained"
                                                            color="success"
                                                            size="small"
                                                            sx={{ minWidth: 32, height: 26, padding: '0 8px', fontSize: '0.75rem' }}
                                                            onClick={() => handleUpdateBalance(chat_id, parseFloat(userAmounts[chat_id]))}
                                                        >
                                                            +
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            size="small"
                                                            sx={{ minWidth: 32, height: 26, padding: '0 8px', fontSize: '0.75rem' }}
                                                            onClick={() => handleUpdateBalance(chat_id, -parseFloat(userAmounts[chat_id]))}
                                                        >
                                                            -
                                                        </Button>
                                                    </Stack>
                                                    <Stack direction="row" spacing={0.75} alignItems="center" flexWrap="wrap">
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        sx={{ minWidth: 48, height: 26, padding: '0 8px', fontSize: '0.7rem' }}
                                                        onClick={() => handleViewPaymentMethod(chat_id)}
                                                    >
                                                        VPM
                                                    </Button>
                                                        {users[chat_id].can_take_number ? (
                                                            <Button
                                                                color="error"
                                                                size="small"
                                                                sx={{ minWidth: 64, height: 26, padding: '0 8px', fontSize: '0.7rem' }}
                                                                onClick={() => handleRestrictUser(chat_id)}
                                                            >
                                                                Restrict
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                color="success"
                                                                size="small"
                                                                sx={{ minWidth: 64, height: 26, padding: '0 8px', fontSize: '0.7rem' }}
                                                                onClick={() => handleUnrestrictUser(chat_id)}
                                                            >
                                                                Unrst
                                                            </Button>
                                                        )}
                                                        <Button
                                                            variant="outlined"
                                                            color="error"
                                                            size="small"
                                                            sx={{ minWidth: 64, height: 26, padding: '0 8px', fontSize: '0.7rem' }}
                                                            onClick={() => handleRemoveUser(chat_id)}
                                                        >
                                                            Remove
                                                        </Button>
                                                    </Stack>
                                                </Stack>
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontSize: 13.1, fontWeight: 200 }}
                                                align="center"
                                                style={{
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 1,
                                                    paddingRight: 1,
                                                }}
                                            >
                                                ₱ {users[chat_id].balance}
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontSize: 13.1, fontWeight: 200, display: { xs: 'none', sm: 'table-cell' } }}
                                                align="center"
                                                style={{
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 1,
                                                    paddingRight: 1,
                                                }}
                                            >
                                                <Switch
                                                    size="small"
                                                    checked={users[chat_id].group_notifications_enabled ?? true}
                                                    onChange={e => handleToggleGroupNotification(chat_id, e.target.checked)}
                                                />
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontSize: 13.1, fontWeight: 200, display: { xs: 'none', sm: 'table-cell' } }}
                                                align="center"
                                                style={{
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 1,
                                                    paddingRight: 1,
                                                }}
                                            >
                                                <Stack
                                                    direction={{ xs: 'column', sm: 'row' }}
                                                    spacing={0.75}
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    flexWrap="wrap"
                                                    sx={{ rowGap: 0.5 }}
                                                >
                                                    <TextField
                                                        value={userAmounts[chat_id] || ''}
                                                        onChange={e => setUserAmounts({ ...userAmounts, [chat_id]: e.target.value })}
                                                        variant="outlined"
                                                        size="small"
                                                        sx={{
                                                            width: 56,
                                                            '& .MuiOutlinedInput-root': {
                                                                minHeight: 24,
                                                                fontSize: '0.75rem',
                                                                padding: 0,
                                                                backgroundColor: 'rgba(255,255,255,0.04)',
                                                            },
                                                            '& .MuiOutlinedInput-input': {
                                                                padding: '4px 8px',
                                                                textAlign: 'center',
                                                            },
                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                borderColor: 'rgba(255,255,255,0.12)',
                                                            },
                                                        }}
                                                    />
                                                    <Button
                                                        variant="contained"
                                                        color="success"
                                                        size="small"
                                                        sx={{
                                                            minWidth: 28,
                                                            height: 24,
                                                            padding: '0 6px',
                                                            fontSize: '0.75rem',
                                                        }}
                                                        onClick={() => handleUpdateBalance(chat_id, parseFloat(userAmounts[chat_id]))}
                                                    >
                                                        +
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        sx={{
                                                            minWidth: 28,
                                                            height: 24,
                                                            padding: '0 6px',
                                                            fontSize: '0.75rem',
                                                        }}
                                                        onClick={() => handleUpdateBalance(chat_id, -parseFloat(userAmounts[chat_id]))}
                                                    >
                                                        -
                                                    </Button>
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        sx={{
                                                            minWidth: 36,
                                                            height: 24,
                                                            padding: '0 6px',
                                                            fontSize: '0.7rem',
                                                        }}
                                                        onClick={() => handleViewPaymentMethod(chat_id)}
                                                    >
                                                        VPM
                                                    </Button>
                                                    {users[chat_id].can_take_number ? (
                                                        <Button
                                                            color="error"
                                                            size="small"
                                                            sx={{
                                                                minWidth: 56,
                                                                height: 24,
                                                                padding: '0 6px',
                                                                fontSize: '0.7rem',
                                                            }}
                                                            onClick={() => handleRestrictUser(chat_id)}
                                                        >
                                                            Restrict
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            color="success"
                                                            size="small"
                                                            sx={{
                                                                minWidth: 56,
                                                                height: 24,
                                                                padding: '0 6px',
                                                                fontSize: '0.7rem',
                                                            }}
                                                            onClick={() => handleUnrestrictUser(chat_id)}
                                                        >
                                                            Unrst
                                                        </Button>
                                                    )}
                                                    <Button
                                                        variant="outlined"
                                                        color="error"
                                                        size="small"
                                                        sx={{
                                                            minWidth: 56,
                                                            height: 24,
                                                            padding: '0 6px',
                                                            fontSize: '0.7rem',
                                                        }}
                                                        onClick={() => handleRemoveUser(chat_id)}
                                                    >
                                                        Remove
                                                    </Button>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                    <TableRow>
                                        <TableCell sx={{ fontSize: 13.5, fontWeight: 200 }} align="center" style={{ fontWeight: 'bold' }}>
                                            Total
                                        </TableCell>
                                        <TableCell sx={{ fontSize: 13.5, fontWeight: 200 }} align="center" style={{ fontWeight: 'bold' }}>
                                            ₱ {totalBalance}
                                        </TableCell>
                                        <TableCell sx={{ fontSize: 13.5, fontWeight: 200, display: { xs: 'none', sm: 'table-cell' } }} align="center" style={{ fontWeight: 'bold' }}>
                                            -
                                        </TableCell>
                                        <TableCell sx={{ fontSize: 13.5, fontWeight: 200, display: { xs: 'none', sm: 'table-cell' } }} align="center" style={{ fontWeight: 'bold' }}>
                                            {totalBalance / 5} Sim
                                        </TableCell>

                                    </TableRow>
                                </TableBody>
                                    </Table>
                                </TableContainer>
                        </Paper>
                    </Grid>
                )}


                <Dialog open={restrictDialogOpen} onClose={() => setRestrictDialogOpen(false)}>
                    <DialogTitle>Restrict {usernameToRestrict} ?</DialogTitle>
                    <DialogContent>
                        <TextField
                            label="Reason"
                            multiline
                            fullWidth
                            rows={3}
                            value={restrictReason}
                            onChange={(e) => setRestrictReason(e.target.value)}
                            variant="outlined"
                        />
                    </DialogContent>
                    <DialogActions>

                        <Button onClick={confirmRestrictUser} color="error" variant="contained">
                            Restrict
                        </Button>
                        <Button onClick={() => setRestrictDialogOpen(false)}>Cancel</Button>
                    </DialogActions>
                </Dialog>


                <Dialog open={showPaymentMethodDialog} onClose={() => setShowPaymentMethodDialog(false)}>
                    <DialogTitle>Payment Method of {selectedUsername}</DialogTitle>
                    <DialogContent>
                        <p>{paymentMethod} </p>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setShowPaymentMethodDialog(false)}>Close</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={resetAllDialogOpen} onClose={() => setResetAllDialogOpen(false)}>
                    <DialogTitle>Reset all balances?</DialogTitle>
                    <DialogContent>
                        <Typography sx={{ fontSize: 14 }}>
                            This will set every user balance to 0. Continue?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setResetAllDialogOpen(false)}>Cancel</Button>
                        <Button
                            color="warning"
                            variant="contained"
                            onClick={() => {
                                setResetAllDialogOpen(false);
                                handleResetBalances();
                            }}
                        >
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>




                {/* Fetched Numbers Section */}
                {showFetchedNumbers && (
                    <Grid item xs={12}>
                        <Paper
                            elevation={0}
                            sx={{
                                p: 1,
                                borderRadius: 2,
                                background: 'rgba(18, 18, 22, 0.75)',
                                border: '1px solid rgba(255,255,255,0.06)',
                                backdropFilter: 'blur(6px)',
                            }}
                        >
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                                <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'rgba(255,255,255,0.8)' }}>
                                    Fetched Numbers
                                </Typography>
                            </Stack>
                            <TableContainer
                                component={Paper}
                                sx={{
                                    borderRadius: 2,
                                    overflowX: 'hidden',
                                    background: 'rgba(14, 16, 20, 0.9)',
                                }}
                            >
                                <Table
                                    stickyHeader
                                    size="small"
                                    sx={{
                                        "& td": { color: "rgba(255,255,255,0.82)", borderColor: "rgba(255,255,255,0.06)" },
                                        "& td, & th": { whiteSpace: 'normal', wordBreak: 'break-word', padding: '4px 5px' },
                                        "& th": { fontSize: 12.5 },
                                    }}
                                >
                                <TableHead sx={{ '& th': { backgroundColor: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.7)', fontWeight: 600 } }}>
                                    <TableRow>
                                        <TableCell
                                            sx={{ fontSize: 13, fontWeight: 500, color: 'text.primary' }}
                                            align="center"
                                            style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}
                                        >
                                            GoIP | Port
                                        </TableCell>
                                        {isDesktop && (
                                            <TableCell
                                                sx={{ fontSize: 13, fontWeight: 500, color: 'text.primary' }}
                                                align="center"
                                                style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}
                                            >
                                                Number
                                            </TableCell>
                                        )}
                                        <TableCell
                                            sx={{ fontSize: 13, fontWeight: 500, color: 'text.primary' }}
                                            align="center"
                                            style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}
                                        >
                                            Status
                                        </TableCell>
                                        <TableCell
                                            sx={{ fontSize: 13, fontWeight: 500, color: 'text.primary' }}
                                            align="center"
                                            style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}
                                        >
                                            Taken
                                        </TableCell>
                                        <TableCell
                                            sx={{ fontSize: 13, fontWeight: 500, color: 'text.primary' }}
                                            align="center"
                                            style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}
                                        >
                                            Timer
                                        </TableCell>
                                        
                                        <TableCell
                                            sx={{ fontSize: 13, fontWeight: 500, color: 'text.primary' }}
                                            align="center"
                                            style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 1 }}
                                        >
                                            OTPs
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {fetchedNumbers.map((number, index) => {
                                        const {
                                            goip,
                                            port,
                                            status,
                                            notes,
                                            mostRecentNote,
                                            takenBy,
                                            timer,
                                            additionalStatus,
                                            takenCount,
                                            otps,
                                            mostRecentOtp,
                                        } = getNumberInfo(number, index);
                                        const statusDisplay = getStatusDisplay(status, mostRecentNote);

                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    '&:last-child td, &:last-child th': {},
                                                    cursor: 'pointer',
                                                    '&:hover': {
                                                        backgroundColor: 'rgba(78, 118, 255, 0.18)',
                                                    },
                                                }}
                                            >
                                            <TableCell
                                                sx={{ fontSize: 13.1, fontWeight: 200 }}
                                                align="center"
                                                style={{
                                                    paddingTop: 0,
                                                    paddingBottom: 0,
                                                    paddingLeft: 1,
                                                        paddingRight: 1,
                                                    }}
                                                >
                                                    {goip} | {port}
                                                </TableCell>
                                                {isDesktop && (
                                                    <TableCell
                                                        sx={{ fontSize: 13.1, fontWeight: 200 }}
                                                        align="center"
                                                        style={{
                                                            paddingTop: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 1,
                                                            paddingRight: 1,
                                                        }}
                                                    >
                                                        {number}
                                                    </TableCell>
                                                )}
                                                <TableCell
                                                    sx={{
                                                        fontSize: 13.1,
                                                        fontWeight: 200,
                                                        paddingTop: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 1,
                                                        paddingRight: 1,
                                                    }}
                                                    align="center"
                                                >
                                                    <Tooltip title={notes}>
                                                        <Stack direction="row" spacing={0.5} alignItems="center" justifyContent="center">
                                                            {statusDisplay.icon}
                                                            {isDesktop && (
                                                                <Typography component="span" sx={{ fontSize: 12.5, color: statusDisplay.color }}>
                                                                    {statusDisplay.label}
                                                                </Typography>
                                                            )}
                                                        </Stack>
                                                    </Tooltip>
                                                </TableCell>


                                                <TableCell
                                                    sx={{ fontSize: 13.1, fontWeight: 200 }}
                                                    align="center"
                                                    style={{
                                                        paddingTop: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 1,
                                                        paddingRight: 1,
                                                    }}
                                                >
                                                    {takenBy}
                                                </TableCell>
                                                <TableCell
                                                    sx={{ fontSize: 13.1, fontWeight: 200 }}
                                                    align="center"
                                                    style={{
                                                        paddingTop: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 1,
                                                        paddingRight: 1,
                                                    }}
                                                >
                                                    {timer}
                                                </TableCell>
                                                <TableCell
                                                    sx={{ fontSize: 13.1, fontWeight: 200 }}
                                                    align="center"
                                                    style={{
                                                        paddingTop: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 1,
                                                        paddingRight: 1,
                                                    }}
                                                >
                                                    <Tooltip title={otps.join(', ')}>
                                                        <span>{otps.length}</span>
                                                    </Tooltip>
                                                </TableCell>

                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                                    </Table>
                                </TableContainer>
                        </Paper>
                    </Grid>
                )}

                {/* Edit Goip Dialog */}
                <Dialog
                    open={openEditBatchesDialog}
                    onClose={() => setOpenEditBatchesDialog(false)}
                >
                    <DialogTitle>Edit Goip</DialogTitle>
                    <DialogContent>
                        {switchStates.map((state, index) =>
                            index > 0 && (
                                <FormControlLabel
                                    control={<Switch checked={state} onChange={() => handleSwitchChange(index)} />}
                                    label={`G${index}`}
                                    key={index}
                                />
                            )
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenEditBatchesDialog(false)}>Cancel</Button>
                        <Button onClick={handleEditBatches}>Submit</Button>
                    </DialogActions>
                </Dialog>

                {/* Remove User Confirmation Dialog */}
                <Dialog open={userRemoveDialogOpen} onClose={() => setUserRemoveDialogOpen(false)}>
                    <DialogTitle>Confirm Removal</DialogTitle>
                    <DialogContent>
                        <p>Are you sure you want to remove {usernameToRemove}?</p>
                    </DialogContent>
                    <DialogActions>

                        <Button onClick={confirmRemoveUser} color="secondary">
                            Remove
                        </Button>
                        <Button onClick={() => setUserRemoveDialogOpen(false)}>Cancel</Button>
                    </DialogActions>
                </Dialog>
                </Grid>
                    </Stack>
                </Container>
            </Box>
        </ThemeProvider>
    );
}

export default Simregbot;
